import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-bg-canvas text-center">
      <div className="text-7xl font-bold tracking-tight text-text-tertiary">404</div>
      <p className="mt-4 text-text-secondary">页面未找到</p>
      <p className="mt-1 text-sm text-text-tertiary">你访问的页面不存在或已被移除</p>
      <Link to="/" className="btn btn-primary btn-md mt-8 shadow-sm">
        返回首页
      </Link>
    </div>
  );
}
